export default __webpack_public_path__ + "static/media/pause_circle_yellow.aadbe598.svg";